/** Componenti — accounting module and readyToClose are disabled for this company. */
export const ACCOUNTING_DISABLED_COMPANY_ID = 'vXxvVIjmbKt5XTusXbhD'

export function isAccountingEnabled(companyId) {
    return String(companyId) !== ACCOUNTING_DISABLED_COMPANY_ID
}
